<template>
  <div>
    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="操作人员" suffix-icon="el-icon-search" v-model="operName"></el-input>
      <el-input style="width: 200px; margin-left: 5px" placeholder="日志标题" suffix-icon="el-icon-search" v-model="title"></el-input>
      <el-select v-model="status" placeholder="操作状态" clearable style="width: 150px; margin-left: 5px">
        <el-option label="正常" :value="0"></el-option>
        <el-option label="异常" :value="1"></el-option>
      </el-select>
      <el-select v-model="userAgent" placeholder="用户类别" clearable style="width: 150px; margin-left: 5px">
        <el-option label="PC端用户" value="PC端用户"></el-option>
        <el-option label="移动端用户" value="移动端用户"></el-option>
        <el-option label="其它" value="其它"></el-option>
      </el-select>
      <el-button class="ml-5" type="primary" @click="load">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>

    <div style="margin: 10px 0">
      <el-popconfirm
          class="ml-5"
          confirm-button-text='确定'
          cancel-button-text='我再想想'
          icon="el-icon-info"
          icon-color="red"
          title="您确定批量删除这些数据吗？"
          @confirm="delBatch"
      >
        <el-button type="danger" slot="reference">批量删除 <i class="el-icon-remove-outline"></i></el-button>
      </el-popconfirm>
    </div>

    <el-table
        :data="tableData"
        border
        stripe
        :header-cell-class-name="'headerBg'"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="title" label="日志标题" width="150"></el-table-column>
      <el-table-column prop="operName" label="操作人员" width="120" align="center"></el-table-column>
      <el-table-column prop="requestUrl" label="请求URL" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="operIp" label="主机地址" width="140" align="center"></el-table-column>
      <el-table-column prop="position" label="地理位置" width="200" align="center"></el-table-column>
      <el-table-column prop="status" label="操作状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'" size="small">
            {{ scope.row.status === 0 ? '正常' : '异常' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="userAgent" label="用户类别" width="120" align="center"></el-table-column>
      <el-table-column prop="createTime" label="操作时间" width="180" align="center"></el-table-column>

      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleDetail(scope.row)">详情 <i class="el-icon-view"></i></el-button>
          <el-popconfirm
              class="ml-5"
              confirm-button-text='确定'
              cancel-button-text='我再想想'
              icon="el-icon-info"
              icon-color="red"
              title="您确定删除吗？"
              @confirm="del(scope.row.id)"
          >
            <el-button type="danger" size="small" slot="reference">删除 <i class="el-icon-remove-outline"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div style="padding: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 详情对话框 -->
    <el-dialog title="操作日志详情" :visible.sync="dialogDetailVisible" width="900px" :close-on-click-modal="false">
      <el-descriptions :column="3" border size="medium" label-class-name="detail-label">
        <el-descriptions-item label="日志标题">{{ detailData.title }}</el-descriptions-item>
        <el-descriptions-item label="操作人员">{{ detailData.operName }}</el-descriptions-item>
        <el-descriptions-item label="操作状态">
          <el-tag :type="detailData.status === 0 ? 'success' : 'danger'" size="small">
            {{ detailData.status === 0 ? '正常' : '异常' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="请求URL" :span="3">{{ detailData.requestUrl }}</el-descriptions-item>
        <el-descriptions-item label="主机地址">{{ detailData.operIp }}</el-descriptions-item>
        <el-descriptions-item label="地理位置">{{ detailData.position }}</el-descriptions-item>
        <el-descriptions-item label="用户类别">{{ detailData.userAgent }}</el-descriptions-item>
        <el-descriptions-item label="操作时间" :span="3">{{ detailData.createTime }}</el-descriptions-item>
        <el-descriptions-item label="请求参数" :span="3">
          <div style="max-height: 200px; overflow-y: auto; word-break: break-all;">
            {{ detailData.operParam || '无' }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="错误消息" :span="3" v-if="detailData.status === 1">
          <div style="max-height: 200px; overflow-y: auto; word-break: break-all; color: #f56c6c;">
            {{ detailData.errorMsg || '无' }}
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OperLog",
  data() {
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      operName: "",
      title: "",
      status: null,
      userAgent: "",
      dialogDetailVisible: false,
      detailData: {},
      multipleSelection: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.request.get("/oper-log/page", {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          operName: this.operName,
          title: this.title,
          status: this.status,
          userAgent: this.userAgent
        }
      }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    handleDetail(row) {
      // 调用详情接口获取完整数据
      this.request.get("/oper-log/" + row.id).then(res => {
        if (res.code === '200') {
          this.detailData = res.data
          this.dialogDetailVisible = true
        } else {
          this.$message.error(res.msg || "获取详情失败")
        }
      }).catch(err => {
        this.$message.error("获取详情失败")
      })
    },
    del(id) {
      this.request.delete("/oper-log/" + id).then(res => {
        if (res.code === '200') {
          this.$message.success("删除成功")
          this.load()
        } else {
          this.$message.error("删除失败")
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    delBatch() {
      if (!this.multipleSelection.length) {
        this.$message.error("请选择需要删除的数据")
        return
      }
      let ids = this.multipleSelection.map(v => v.id)
      this.request.post("/oper-log/del/batch", ids).then(res => {
        if (res.code === '200') {
          this.$message.success("批量删除成功")
          this.load()
        } else {
          this.$message.error("批量删除失败")
        }
      })
    },
    reset() {
      this.operName = ""
      this.title = ""
      this.status = null
      this.userAgent = ""
      this.pageNum = 1
      this.load()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.load()
    }
  }
}
</script>

<style scoped>
.headerBg {
  background: #eee!important;
}

/* 详情对话框 label 样式 */
::v-deep .detail-label {
  width: 120px !important;
  min-width: 120px !important;
  white-space: nowrap !important;
  background-color: #fafafa !important;
  font-weight: 600 !important;
}
</style>
